(function () {
  'use strict';

  angular
      .module('tf.retailer.Util')
      .directive('tfcAnchorScroll', AnchorScroll);

  // @ngInject
  function AnchorScroll() {
    return {
      restrict: 'A',
      scope: {
        currentPage: '='
      },
      link : function ($scope, $el) {
        $scope.$watch('currentPage', function(newValue, oldValue){
          if(oldValue!=newValue){
            $el[0].parentNode.scrollIntoView({block: 'start', behaviour : 'smooth'});
          }
        });
      }
    };
  }

})();
